<template>
  <div class="content">

    <toolbar v-bind:selection="toolbar" title="Panimiel" />

      <p v-if="userLogged">Usuario logueado: <b>{{userLogged}}</b> - <a href="" @click="deleteCookie()"><v-icon color="grey">mdi-logout</v-icon></a></p>

 <div class="card">


     <p class="title-box">DATOS GENERALES</p>
    <p>Colmenares: {{info.colmenares}} </p>
    <p>Colmenas: {{info.colmenas}}</p>
     <p>Núcleos: {{info.nucleos}}</p>
     <p>Reinas: {{info.queens}}</p>

     <p class="title-box">REINAS ({{info.queens}})</p>
     <p>
     <span v-if="info.queens>0" v-for="queen in queens" :key="queen.id">
         {{queen.year}} ({{queen.count}})
     </span>

     </p>

     <p class="title-box">COLMENAS ({{info.colmenas}})</p>
     <p>Con reina ({{info.hives_with_queen}}) - sin reina ({{info.colmenas-info.hives_with_queen}})</p>


     <p class="title-box">NÚCLEOS ({{info.nucleos}})</p>
     <p>Con reina ({{info.core_with_queen}}) - sin reina ({{info.nucleos-info.core_with_queen}})</p>


 </div>

    <menubottom active="0" />

  </div>

</template>

<script>
import auth from "@/libs/auth"

import menubottom from "@/components/MenuBottom"
import toolbar from "@/components/Toolbar"
import colmenares from "@/components/Colmenares"
import axios from "axios";

export default {
  name: 'app',
  components: {
    colmenares,
    toolbar,
    menubottom
  },
  computed: {
    userLogged() {
        return auth.getUserLogged()
    }
  },

  data() {
      return {
          toolbar: [],
           info: null,
           queens: null,
        }
  },
  created() {



        var that = this
        axios.get("https://appws.panimiel.com/new/index.php/api/dashboard/").then((info) => {
          that.info = info.data
        })

        axios.get("https://appws.panimiel.com/new/index.php/api/dashboard/queens").then((queens) => {
          that.queens = queens.data
        })

  },
    methods:{

    deleteCookie(){
        return auth.deleteUserLogged();
    }

    }

}
</script>

<style scoped lang="scss">
</style>